import React, { useEffect, useState } from "react";
import { CgMenuLeftAlt } from "react-icons/cg";
import { FaBell, FaUserCircle } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../store/slices/auth";

export default function HotelHeaderNav({ onMenuClick }) {

  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showCard, setShowCard] = useState(false);

  const userName = user?.data?.name;
  const userEmail = user?.data?.email;

  useEffect(() => { }, [user]);

  const finalStats = {
    checkIns: 5,
    checkOuts: 3,
    occupancy: 78,
    notifications: 2,
  };

  const [stats, setStats] = useState({
    checkIns: 0,
    checkOuts: 0,
    occupancy: 0,
    notifications: 0,
  });

  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setStats((prev) => ({
        checkIns:
          prev.checkIns < finalStats.checkIns
            ? prev.checkIns + 1
            : prev.checkIns,
        checkOuts:
          prev.checkOuts < finalStats.checkOuts
            ? prev.checkOuts + 1
            : prev.checkOuts,
        occupancy:
          prev.occupancy < finalStats.occupancy
            ? prev.occupancy + 1
            : prev.occupancy,
        notifications:
          prev.notifications < finalStats.notifications
            ? prev.notifications + 1
            : prev.notifications,
      }));
    }, 20);

    return () => clearInterval(interval);
  }, [
    finalStats.checkIns,
    finalStats.checkOuts,
    finalStats.notifications,
    finalStats.occupancy,
  ]);

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 992 && window.innerWidth > 600);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLogout = async () => {
    try {
      await dispatch(logout()).unwrap();
      setShowCard(false);

      navigate("/login", { replace: true });
    } catch (error) {
      console.log("Logout error:", error);
    }
  };

  return (
    <header className="header">
      <div className="header-left">
        <CgMenuLeftAlt
          size={28}
          className="menu-btn"
          onClick={onMenuClick}
          style={{ color: "#f4c430" }}
        />
        <h6 className="welcome-text" style={{ color: "white" }}>
          WELCOME!
        </h6>
      </div>

      <div className="header-icons">
        {/* Notification */}
        <div className="icon-wrapper notification">
          <FaBell size={18} />
          {stats.notifications > 0 && (
            <span className="notification-badge">{stats.notifications}</span>
          )}
        </div>

        {/* User */}
        <div
          className="icon-wrapper user position-relative"
          onMouseEnter={() => setShowCard(true)}
        >
          <FaUserCircle size={22} className="profile-icon" />

          {showCard && (
            <div className="profile-hover-card my-2 position-absolute">
              <div
                style={{
                  position: "absolute",
                  top: "8px",
                  right: "10px",
                  cursor: "pointer",
                  fontSize: "14px",
                  fontWeight: "bold",
                }}
                onClick={() => setShowCard(false)}
              >
                ✖
              </div>

              <div className="profile-top d-flex align-items-center gap-3 mt-3">
                <FaUserCircle size={45} className="rounded-circle" />

                <div>
                  <div className="fw-bold mb-0">{userName}</div>
                  <div className="small">{userEmail}</div>
                </div>
              </div>

              <hr className="my-2" />

              <Link to="/hotel/profile" style={{ textDecoration: "none" }}>
                <div className="profile-item">Profile</div>
              </Link>


              <Link to="/changepassword" style={{ textDecoration: "none" }}>
                <div className="profile-item">Change Password</div>
              </Link>

              <div
                className="profile-item text-danger"
                onClick={handleLogout}
                style={{ cursor: "pointer" }}
              >
                Logout
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
